import { colors } from '@dixa/lib-shared-tokens';
import { Graphics, MSAA_QUALITY, Sprite } from 'pixi.js';
import { useEffect, useState } from 'react';
import { useEditorContext } from 'flow-builder/editor.context';
import { HighlightType } from 'flow-builder/types/node';
import { styles as commonStyles } from '../common/commonStyles';
import { getIconTextures } from '../utils/icons';
import { styles } from './actionNodeStyles';
const textureGenerationSettings = {
    resolution: window.devicePixelRatio * 2,
    multisample: MSAA_QUALITY.HIGH,
};
const iconStyles = { fill: colors.neutral['000'], size: 40 };
export const useActionNodeTextures = () => {
    const { view } = useEditorContext();
    const [textures, setTextures] = useState(null);
    useEffect(() => {
        if (!view.isReady) {
            return;
        }
        getIconTextures(['plus'], iconStyles).then(({ plus }) => {
            const drawFunc = (color) => {
                const circle = new Graphics();
                const icon = new Sprite(plus);
                circle.beginFill(color);
                circle.drawCircle(0, 0, styles._circle.radius);
                circle.endFill();
                icon.width = 20;
                icon.height = 20;
                icon.anchor.set(0.5, 0.5);
                circle.addChild(icon);
                return circle;
            };
            setTextures({
                [HighlightType.NONE]: view.app.renderer.generateTexture(drawFunc(styles._circle.color), textureGenerationSettings),
                [HighlightType.INFO]: view.app.renderer.generateTexture(drawFunc(commonStyles.highlight[HighlightType.INFO]), textureGenerationSettings),
                [HighlightType.ERROR]: view.app.renderer.generateTexture(drawFunc(commonStyles.highlight[HighlightType.ERROR]), textureGenerationSettings),
            });
        });
    }, [view.isReady, view.app, setTextures]);
    return textures;
};
